<app-container class="flex justify-center container" ngClass.xs="xs" [maxWidth]="handsetService.isXs ? '100%' : '552px'"
               [noPadding]="handsetService.isMobile">
  <app-card [title]="'Wyślij na e-mail'"
            [subtitle]="'Jak to działa?'" [titleStyle]="{'text-align': 'left'}"
            [subtitleStyle]="{'text-align': 'left'}">
    <div content>
      <div class="font-medium">
        <ul class="list-block">
          <li>Dostałeś rachunek na swój prywatny adres email, który moglibyśmy odroczyć?</li>
          <li>Prześlij go na poniższy adres e-mail, który przypisaliśmy do Twojego konta.</li>
          <li>Automatycznie go odczytamy i poinformujemy Cię o tym w powiadomieniach.
            <app-icon name="notifications_active"
                      style="display: inline; vertical-align: middle;"
                      [height]="20" [width]="20"></app-icon>
          </li>
        </ul>
      </div>
      <mat-form-field
        (click)="onCopied()"
        [cbContent]="inboxEmailAddress"
        appearance="outline"
        class="inbox-email-address"
        ngxClipboard>
        <mat-label>Przesyłaj rachunki na</mat-label>
        <input matInput type="text" autocomplete="off" [value]="inboxEmailAddress" readonly />
        <app-icon [@iconAnimation]="copied ? 'true' : 'false'"  [ngClass]="{'icon-visible': !copied, 'icon-hidden': copied}" name="filter_none" matSuffix></app-icon>
        <app-icon [@iconAnimation]="copied ? 'true' : 'false'" [ngClass]="{'icon-visible': copied, 'icon-hidden': !copied}" name="check" matSuffix></app-icon>
      </mat-form-field>
    </div>

    <div buttons>
      <div class="text-center">
        <button type="button" class="back-button button-250" (click)="goBack()" fxShow mat-button>Wróć
        </button>
      </div>
    </div>
  </app-card>
</app-container>
